import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { MapBudgetField } from "../../common/salescredit/salescredit-budget-helper";
import colors from "../../common/utils/colors";
import { Format } from "../../common/utils/format";
import { ISalesCreditMonthData } from "./types";

export const Helper = {
  BuildChartOptionsTwo,
  MapMonthData,
  MonthList: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"],
};

// tslint:disable-next-line: cognitive-complexity
export function MapMonthData(
  rawdata: IGenericAggregateResponse,
  budgetdata?: IGenericAggregateResponse,
  useBudget = false
) {
  const mapedMonthData: ISalesCreditMonthData = {
    Budget: [],
    Mtd: [],
    Mtd_Y1: [],
    Symbol: "K",
    Y1: 0,
    Y2: 0,
  };
  mapedMonthData.Y1 = Format.GetYear(
    rawdata.request ? rawdata.request.date : ""
  );
  mapedMonthData.Y2 = mapedMonthData.Y1 - 1;
  const million = 1000000;
  const billion = 1000000000;
  let rowCount = 0;
  for (let index = 1; index <= Helper.MonthList.length; index++) {
    if (
      rawdata.aggregates &&
      rawdata.aggregates[rowCount] &&
      index ===
        Number(
          rawdata.aggregates[rowCount].dimensionAttributeValues.period_month_id
        )
    ) {
      const ytd =
        rawdata.aggregates[rowCount].indicatorKpiValues[SCKpis.SC_YTD];
      const ytd1 =
        rawdata.aggregates[rowCount].indicatorKpiValues[SCKpis.SC_SC_1];

      let budget = NaN;
      if (
        useBudget &&
        budgetdata &&
        budgetdata.aggregates &&
        budgetdata.aggregates[rowCount] &&
        index ===
          Number(
            budgetdata.aggregates[rowCount].dimensionAttributeValues
              .period_month_id
          )
      ) {
        budget = MapBudgetField(
          budgetdata.aggregates[rowCount].indicatorKpiValues,
          "budget"
        );
      }
      const budgetConverted = !isNaN(budget) ? budget / 12 : 0;

      if (
        mapedMonthData.Symbol === "K" &&
        (ytd > million ||
          ytd1 > million ||
          (budgetConverted > million && useBudget))
      ) {
        mapedMonthData.Symbol = "M";
      }

      if (
        mapedMonthData.Symbol === "M" &&
        (ytd > billion ||
          ytd1 > billion ||
          (budgetConverted > billion && useBudget))
      ) {
        mapedMonthData.Symbol = "B";
      }

      if (!isNaN(budget)) {
        mapedMonthData.Budget.push({
          desc: !isNaN(ytd)
            ? "(" + Format.FormatYoY(ytd / budgetConverted, true) + ")"
            : "",
          x: index - 1,
          y: budgetConverted,
        });
      }
      mapedMonthData.Mtd.push({
        desc:
          "(" +
          Format.FormatYoY(
            rawdata.aggregates[rowCount].indicatorKpiValues[SCKpis.SC_YOY_PER],
            true
          ) +
          " YoY)",
        x: index - 1,
        y: ytd,
      });
      mapedMonthData.Mtd_Y1.push(ytd1);
      rowCount++;
    } else {
      mapedMonthData.Budget.push({
        desc: "",
        x: index - 1,
        y: 0,
      });
      mapedMonthData.Mtd.push({
        desc: "",
        x: index - 1,
        y: 0,
      });
      mapedMonthData.Mtd_Y1.push(0);
    }
  }

  ConvertData(mapedMonthData);
  return mapedMonthData;
}

export function BuildChartOptionsTwo(
  data: ISalesCreditMonthData,
  useBudget = false
) {
  return {
    colors,
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        grouping: false,
        shadow: false,
      },
    },
    series: useBudget
      ? GetSeriesWithBudget(data)
      : GetSeriesWithOutBudget(data),
    title: {
      text: "",
    },
    tooltip: {
      crosshairs: true,
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y:,.2f} ' +
        data.Symbol +
        "€</b> {point.desc}<br/>",
      shared: true,
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      crosshair: true,
    },
    yAxis: {
      labels: {
        format: "{value} " + data.Symbol,
      },
      title: {
        text: "Sales Credit (" + data.Symbol + "€)",
      },
    },
  };
}

function ConvertNumber(value: number, symbol: string): number {
  switch (symbol) {
    case "K": {
      return Format.FormatNumber(value, 1000, 2);
    }
    case "M": {
      return Format.FormatNumber(value, 1000000, 2);
    }
    case "B": {
      return Format.FormatNumber(value, 1000000000, 2);
    }
    default: {
      return Format.FormatNumber(value, 1000, 2);
    }
  }
}

function ConvertData(data: ISalesCreditMonthData) {
  let i: number;
  for (i = 0; i < data.Mtd_Y1.length; i++) {
    if (data.Mtd_Y1[i] == null) {
      continue;
    }
    data.Mtd_Y1[i] = ConvertNumber(data.Mtd_Y1[i], data.Symbol);
  }
  for (i = 0; i < data.Mtd.length; i++) {
    if (data.Mtd[i] == null) {
      continue;
    }

    data.Mtd[i].y = ConvertNumber(data.Mtd[i].y, data.Symbol);
  }
  for (i = 0; i < data.Budget.length; i++) {
    if (data.Budget[i] == null) {
      continue;
    }
    data.Budget[i].y = ConvertNumber(data.Budget[i].y, data.Symbol);
  }
}

function GetSeriesWithBudget(data: ISalesCreditMonthData) {
  return [
    {
      color: "#444852",
      data: data.Mtd,
      name: data.Y1,
      pointPadding: 0.4,
      type: "column",
      zIndex: 1,
    },
    {
      color: "#b4bbcb",
      data: data.Mtd_Y1,
      name: data.Y2,
      pointPadding: 0.2,
      type: "column",
      zIndex: 0,
    },
    {
      color: "#dc4941",
      data: data.Budget,
      lineWidth: 1,
      marker: {
        radius: 0,
      },
      name: data.Y1 + " Budget",
      type: "spline",
      zIndex: 2,
    },
  ];
}

function GetSeriesWithOutBudget(data: ISalesCreditMonthData) {
  return [
    {
      color: "#444852",
      data: data.Mtd,
      name: data.Y1,
      pointPadding: 0.4,
      type: "column",
      zIndex: 1,
    },
    {
      color: "#b4bbcb",
      data: data.Mtd_Y1,
      name: data.Y2,
      pointPadding: 0.2,
      type: "column",
      zIndex: 0,
    },
  ];
}
